import type { ReactNode } from 'react';
import * as s from './MainLayout.css';
import { StatusHud, type StatusHudProps } from '../../organisms/StatusHud';
import { LuminariumBackdrop } from '../../organisms/LuminariumBackdrop';

interface MainLayoutProps {
  headerLeft?: ReactNode;
  headerCenter?: ReactNode;
  headerRight?: ReactNode;
  sidebar?: ReactNode;
  children: ReactNode;
  userStatus?: StatusHudProps;
  sidebarExpanded?: boolean;
  /** 로그아웃 중 — 광원장만 남기고 창·독·상태창을 뺀다 */
  departing?: boolean;
}

export function MainLayout({
  headerLeft,
  headerCenter,
  headerRight,
  sidebar,
  children,
  userStatus,
  sidebarExpanded = false,
  departing = false,
}: MainLayoutProps) {
  return (
    <div
      className={`${s.layout} ${sidebarExpanded ? s.sidebarExpandedGrid : s.sidebarDefault}${departing ? ` ${s.departing}` : ''}`}
    >
      {/* Why: 모달 진행값은 hologramSceneStore가 직접 셰이더 uniform을 갱신.
          Context로 props를 흘려보내던 옛 구조는 제거됨 (매 프레임 React 리렌더 비용). */}
      <LuminariumBackdrop intensity={0.5} />
      {/* 가장자리만 떨궈 chrome 이 밟는 판을 평평하게 만든다. backdrop 다음·chrome 앞이라는
          순서가 곧 기능 — 근거는 MainLayout.css.ts 의 shellVignette 주석. */}
      <div id="shell-vignette" className={s.shellVignette} aria-hidden="true" />

      <header className={s.header}>
        <div className={s.headerLeft}>{headerLeft}</div>
        <div className={s.headerCenter}>{headerCenter}</div>
        <div className={s.headerRight}>{headerRight}</div>
      </header>
      {sidebar && <aside className={s.sidebar}>{sidebar}</aside>}
      <main id="main-content" className={s.content}>
        {children}
      </main>
      <footer className={s.floor}>
        <span className={s.footerText}>© 2026 Crevasse AI. All rights reserved.</span>
      </footer>
      <div className={s.floatingActions} id="floating-actions">
        {userStatus && <StatusHud {...userStatus} />}
      </div>
    </div>
  );
}
